import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../utils/api';

/**
 * Hook for fetching and managing live site statistics
 */
export const useLiveStats = () => {
  const [stats, setStats] = useState({ active_now: 1, today_visits: 0, total_bookings: 0 });
  
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API}/analytics/live-stats`);
        if (res.data?.stats) {
          setStats(res.data.stats);
        }
      } catch (err) {
        console.log('Stats fetch failed');
      }
    };
    
    // Track pageview
    axios.post(`${API}/analytics/pageview`, {
      page: window.location.pathname,
      referrer: document.referrer
    }).catch(() => {});
    
    fetchStats();
    const interval = setInterval(fetchStats, 30000); // Update every 30 seconds
    return () => clearInterval(interval);
  }, []);
  
  return stats;
};

/**
 * Hook for setting SEO meta tags
 */
export const useSEO = (title, description, keywords = null) => {
  useEffect(() => {
    document.title = title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', description);
    }
    
    // Handle keywords if provided
    if (keywords) {
      let keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (!keywordsMeta) {
        keywordsMeta = document.createElement('meta');
        keywordsMeta.setAttribute('name', 'keywords');
        document.head.appendChild(keywordsMeta);
      }
      keywordsMeta.setAttribute('content', keywords);
    }
  }, [title, description, keywords]);
};
